<template>
  <TableList
    v-rect-loading="loading"
    class="company-recharge-list"
    row-key="id"
    noAction
    :title="$t(`${i18nPrefix}.label.cashRechargeListTitle`, {companyName: company.i18nName})"
    :listData="dataList"
    :tableColumns="tableColumns"
    :showCreateBtn="false"
  >
    <template #filter>
      <el-select v-model="selectActivity" clearable @change="handleActivityChange">
        <el-option
          v-for="(item, index) in activityList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </template>
  </TableList>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import { COMPANY_BALANCE_ACTIVITY, COMPANY_REWARD_TYPE } from '@/constant/company'
import { addI18nProperty } from '@/i18n'
import { formatBigNumber } from '@/components/filters'

export default {
  components: {
    TableList
  },
  data () {
    return {
      i18nPrefix: 'admin.company.cashPointsManagement',
      loading: false,
      dataList: [],
      selectActivity: null,
      company: {
        i18nName: null
      }
    }
  },
  computed: {
    companyId () {
      return this.$route.params.companyId
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.purchaseDate`),
          width: '100',
          dataKey: 'confirm_at',
          formatter: (val) => {
            return moment(val).format('YYYY/MM/DD')
          }
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.jobName`),
          width: '200',
          dataKey: 'job.i18nTitle'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.activity`),
          width: '100',
          dataKey: 'activity',
          formatter: (value) => {
            const key = _.get(_.invert(COMPANY_BALANCE_ACTIVITY), value)
            return this.$t(`${this.i18nPrefix}.COMPANY_BALANCE_ACTIVITY.${key}`)
          }
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.cash`),
          dataKey: 'points',
          width: '100',
          formatter: (val) => {
            return formatBigNumber(val)
          }
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.note`),
          width: '200',
          dataKey: 'note'
        }
      ]
      return columns
    },
    activityList () {
      return _.map(COMPANY_BALANCE_ACTIVITY, (val, key) => {
        return {
          label: this.$t(`${this.i18nPrefix}.COMPANY_BALANCE_ACTIVITY.${key}`),
          value: val
        }
      })
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('cashPointsManagement', ['getCompanyRechargeList']),
    initPage () {
      this.loadCompanyRechargeList()
    },
    async loadCompanyRechargeList () {
      this.loading = true
      try {
        const params = {
          reward_type: COMPANY_REWARD_TYPE.CASH,
          activity: this.selectActivity,
          company_id: this.companyId
        }
        const resp = await this.getCompanyRechargeList(params)
        if (resp) {
          _.forEach(resp.list_data, item => {
            if (item.job) {
              addI18nProperty(item.job, 'i18nTitle', 'cn_title', 'title')
            }
          })
          this.dataList = resp.list_data
          addI18nProperty(resp.company, 'i18nName', 'cn_name', 'name')
          this.company = resp.company
        }
      } finally {
        this.loading = false
      }
    },
    handleActivityChange () {
      this.loadCompanyRechargeList()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
